import { colTableRef, fileListRef } from './consts';

export default function(editor, opts = {}) {
  const c = opts;
  const bm = editor.BlockManager;
  const pfx = c.pfx;
  const pfxFile = c.pfxFile;
  const style = `
  <style>
  .${pfx} {
    padding: 2px;
  }
  .${pfxFile} {
    padding: 2px;
  }
  </style>
`;
  if (c.blocks.indexOf(colTableRef) >= 0) {
    bm.add(colTableRef, {
      label: `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="32" height="50"><!-- Font Awesome Free 5.15.3 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) --><path d="M80 368H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm0-320H16A16 16 0 0 0 0 64v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16V64a16 16 0 0 0-16-16zm0 160H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm416 176H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"/></svg>
          <div class="gjs-block-label">${c.labelTable}</div>`,
      category: c.labelCMSCategory,
      content: `
        <div class='${pfx} p-3 width100' style="width:100%;" data-js="child-data-group" data-gjs-type="child-data-group">
            
        </div>
        ${style}          `,
      render: ({ model, className }) => `
        <div class="${className}-label ${className}__drapcode-wrap">
        ${model.get('label')}
        </div>
  
        <span class="${className}__info no-doc">
          <a target="_blank" href="#" draggable="false">
            <i class="${className}__info-fa fa fa-info-circle" style="margin-left: 5px" title="Check how to use ${
        c.labelTable
      }?"></i>
          </a>
        </span>
      `,
    });
  }
  if (c.blocks.indexOf(fileListRef) >= 0) {
    bm.add(fileListRef, {
      label: `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="32" height="50"><!-- Font Awesome Free 5.15.3 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) --><path d="M80 368H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm0-320H16A16 16 0 0 0 0 64v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16V64a16 16 0 0 0-16-16zm0 160H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm416 176H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"/></svg>
          <div class="gjs-block-label">${c.labelFileDatagroup}</div>`,
      category: c.labelCMSCategory,
      content: `
        <div class='${pfxFile} p-3 width100 row' style="width:100%;" data-js="child-data-group-file" data-gjs-type="child-data-group-file">
            
        </div>
        ${style}          `,
      render: ({ model, className }) => `
        <div class="${className}-label ${className}__drapcode-wrap">
        ${model.get('label')}
        </div>
  
        <span class="${className}__info no-doc">
          <a target="_blank" href="#" draggable="false">
            <i class="${className}__info-fa fa fa-info-circle" style="margin-left: 5px" title="Check how to use ${
        c.labelFileDatagroup
      }?"></i>
          </a>
        </span>
      `,
    });
  }
}
